<template>
  <div>
    <ContentHeader title="Update Rate" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-primary">
              <form @submit.prevent="handleUpdateData()">
                <div class="card-body">
                  <div class="form-group">
                    <label for="CORPORATE_PARTNER">Manager Cabang</label>
                    <div class="input-group mb-3">
                      <input
                        type="text" 
                        onkeypress='return event.charCode >= 48 && 
                            event.charCode <= 57 || 
                            event.charCode == 46'
                        min="0" max="100"
                        step="any"
                        class="form-control"
                        id="CORPORATE_PARTNER"
                        :class="{
                          'border-danger':
                            $v.payload.CORPORATE_PARTNER.$error
                        }"
                        placeholder="input Manager Cabang"
                        v-model="payload.CORPORATE_PARTNER"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">%</span>
                      </div>
                    </div>
                    <div
                      class="text-danger"
                      v-if="
                        $v.payload.CORPORATE_PARTNER.$error
                      "
                    >
                      <small>Manager Cabang Required</small>
                    </div>
                    
                  </div>
                  <div class="form-group">
                    <label for="INTRODUCING_BROKER">Agent Level</label>
                    <div class="input-group mb-3">
                      <input
                          type="text" 
                          onkeypress='return event.charCode >= 48 && 
                              event.charCode <= 57 || 
                              event.charCode == 46'
                          min="0" max="100"
                          step="any"
                          class="form-control"
                          id="INTRODUCING_BROKER"
                          placeholder="Input Agent"
                          v-model="payload.INTRODUCING_BROKER"
                          :class="{
                            'border-danger': $v.payload.INTRODUCING_BROKER.$error,
                          }"
                        />
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">%</span>
                      </div>
                    </div>
                    <div
                      class="text-danger"
                      v-if="
                        $v.payload.INTRODUCING_BROKER.$error
                      "
                    >
                      <small>Agent Required</small>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="MASTER_IB">Manager Area</label>
                    <div class="input-group mb-3">
                      <input
                        type="text" 
                          onkeypress='return event.charCode >= 48 && 
                              event.charCode <= 57 || 
                              event.charCode == 46'
                          min="0" max="100"
                          step="any"
                          class="form-control"
                          id="MASTER_IB"
                          :class="{
                            'border-danger':
                              $v.payload.MASTER_IB.$error
                          }"
                          placeholder="input Manager Area"
                          v-model="payload.MASTER_IB"
                        />
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">%</span>
                      </div>
                    </div>
                    <div
                      class="text-danger"
                      v-if="
                        $v.payload.MASTER_IB.$error 
                      "
                    >
                      <small>Manager Area Required</small>
                    </div>
                    
                  </div>
                  <div class="form-group">
                    <label for="PARTNER_IB">Supervisor Area</label>
                    <div class="input-group mb-3">
                      <input
                        type="text" 
                          onkeypress='return event.charCode >= 48 && 
                              event.charCode <= 57 || 
                              event.charCode == 46'
                          min="0" max="100"
                          step="any"
                          class="form-control"
                          id="PARTNER_IB"
                          placeholder="Input Supervisor Area"
                          v-model="payload.PARTNER_IB"
                          :class="{
                            'border-danger': $v.payload.PARTNER_IB.$error,
                          }"
                        />
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">%</span>
                      </div>
                    </div>
                    <div
                      class="text-danger"
                      v-if="
                        $v.payload.PARTNER_IB.$error
                      "
                    >
                      <small>Supervisor Area Required</small>
                    </div>
                    
                  </div>
                </div>
                <div class="row p-2 p-md-3 footer-card">
                  <div class="col-12 col-md-6 p-1">
                  <router-link
                    type="submit"
                    to="/rate"
                    class="btn btn-outline-danger btn-block"
                  >
                    Cancel
                  </router-link>
                  </div>
                  <div class="col-12 col-md-6 p-1">
                    <button
                    type="submit"
                    href="#"
                    class="btn btn-success btn-block"
                    :disabled="submitStatus === 'PENDING'"
                  >
                    Update Rate
                  </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import apiClient from "@/services/ApiServices";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      payload: {
        CORPORATE_PARTNER: "",
        INTRODUCING_BROKER: "",
        MASTER_IB: "",
        PARTNER_IB: "",
      },
      submitStatus: "",
      errorResponse: {},
      id_configuration: `${this.$route.params.id}`,
      isDisabled: false,
    };
  },
  created() {
    document.title = "Update Configuration - Manager Cabang";
  },
  validations: {
    payload: {
      CORPORATE_PARTNER: {
        required,
        // numeric,
      },
      INTRODUCING_BROKER: {
        required,
        // numeric,
      },
      MASTER_IB: {
        required,
        // numeric,
      },
      PARTNER_IB: {
        required,
        // numeric,
      },
    },
  },
  components: {
    ContentHeader,
  },

  async mounted() {
    try {
      let cpRate = await apiClient.get(
        `${this.$user_id}/disbursement/settings/rate/`
      );
      this.payload.CORPORATE_PARTNER = parseInt(cpRate.data.data.CORPORATE_PARTNER*100)
      this.payload.INTRODUCING_BROKER = parseInt(cpRate.data.data.INTRODUCING_BROKER*100)
      this.payload.MASTER_IB = parseInt(cpRate.data.data.MASTER_IB*100)
      this.payload.PARTNER_IB = parseInt(cpRate.data.data.PARTNER_IB*100)
    } catch (error) {
      this.$toasted.show(error.message, {
        theme: "toasted-primary",
        position: "top-right",
        duration: 4000,
      });
    }
  },

  methods: {
    async handleUpdateData() {
      let data = new FormData();
      let dataIB = this.payload.INTRODUCING_BROKER/100
      let dataCP = this.payload.CORPORATE_PARTNER/100
      let dataMasterIB = this.payload.MASTER_IB/100
      let dataPartnerIB = this.payload.PARTNER_IB/100
      console.log(parseInt(dataIB*100))
      data.append("CORPORATE_PARTNER", dataCP);
      data.append("INTRODUCING_BROKER", dataIB);
      data.append("MASTER_IB", dataMasterIB);
      data.append("PARTNER_IB", dataPartnerIB);

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";

        try {
          await apiClient.post(
            `${this.$user_id}/disbursement/settings/rate/`,
            data
          );

          this.$swal(
            "Edited!",
            "Rate has been Edited.",
            "success"
          ).then(() => {
            this.submitStatus = "OK";
            this.$router.push({ name: "Rate" });
          });
          this.isDisabled = false;
        } catch (e) {
          this.submitStatus = "ERROR";
        }
      }
    },
    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
.footer-card{
  flex-direction: column-reverse;
}
@media (min-width: 767px) {
  .footer-card{
    flex-direction: initial;
  }
}

</style>